import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFootFlat = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 71.955,
	height: 33.802,
	viewBox: "0 0 71.955 33.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_179",
		"data-name": "Group 179",
		transform: "translate(0 0)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_176",
			"data-name": "Group 176",
			opacity: 0,
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_359",
				"data-name": "Path 359",
				d: "M867.04,713.768H795.086v-33.8H867.04Zm-71.435-.52h70.915V680.486H795.606Z",
				transform: "translate(-795.086 -679.966)",
				fill: "#040505"
			})
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_178",
			"data-name": "Group 178",
			transform: "translate(20.408 4.928)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_177",
				"data-name": "Group 177",
				transform: "translate(0 0)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_360",
						"data-name": "Path 360",
						d: "M863.606,708.4c1.376-1.128,1.984-2.525,1.627-3.739a2.243,2.243,0,0,0-1.943-1.6c-.385-.044-.827-.088-1.3-.135a22.588,22.588,0,0,1-5.2-.872c-1.432-.71-5.137-3.159-6.664-4.178a1.236,1.236,0,0,0-.7-.2c-.023-.243-.042-.5-.043-.786-.006-1.819.027-6.351.028-6.4a1.039,1.039,0,0,0-1.031-1.047h-.008a1.04,1.04,0,0,0-1.039,1.032c0,.045-.034,4.589-.027,6.419a9.328,9.328,0,0,0,.487,3.056c-.006.034-.012.065-.018.1a3.3,3.3,0,0,1-1.989.26,4.25,4.25,0,0,1-1.523-.842c-.035-.029-.077-.048-.113-.074.066-.373.134-.847.223-1.467a30.1,30.1,0,0,0-.408-6.61,1.04,1.04,0,0,0-2.052.336,27.568,27.568,0,0,1,.4,5.979c-.116.807-.194,1.272-.243,1.536a2.1,2.1,0,0,0-.992.895,10.331,10.331,0,0,0-.771,1.794,18.815,18.815,0,0,0-.815,3.5,6.2,6.2,0,0,0-.99,2.11,1.037,1.037,0,0,0,.138.964,6.466,6.466,0,0,0,4.74,2.192c.847.074,2.25.115,3.821.137a1.036,1.036,0,0,0,.878,1.59h7.608a1.037,1.037,0,0,0,.843-1.644C857.736,710.6,861.5,710.127,863.606,708.4Zm-22.912-.845c.131-.332.255-.621.329-.765l.121-.1a1.046,1.046,0,0,0,.38-.737,15.519,15.519,0,0,1,.76-3.442,7.269,7.269,0,0,1,.633-1.443c.015,0,.02,0,.023,0a6.168,6.168,0,0,0,2.309,1.248,5.671,5.671,0,0,0,4.021-.693,1.041,1.041,0,0,0,.5-.773c.024-.213.06-.44.1-.651,1.977,1.309,4.723,3.084,6,3.718,1.149.569,3.267.815,5.917,1.078.462.046.894.089,1.27.132.155.018.173.08.184.117.072.248-.121.863-.951,1.544-1.617,1.325-5.066,1.8-6.213,1.87-.1,0-9.71.137-12.512-.108A5.38,5.38,0,0,1,840.694,707.557Z",
						transform: "translate(-836.318 -689.448)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_361",
						"data-name": "Path 361",
						d: "M888.427,729.524h-3.118a1.039,1.039,0,0,0,0,2.079h3.118a1.039,1.039,0,1,0,0-2.079Z",
						transform: "translate(-858.328 -708.696)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_362",
						"data-name": "Path 362",
						d: "M838.512,729.524h-3.118a1.039,1.039,0,0,0,0,2.079h3.118a1.039,1.039,0,0,0,0-2.079Z",
						transform: "translate(-834.354 -708.696)",
						fill: "#040505"
					})
				]
			})
		})]
	})]
});
const ForwardRef = forwardRef(SvgFootFlat);
export { ForwardRef as ReactComponent };
